module.exports = __webpack_public_path__ + "d41f55a78e6f49a5512878df1737e58a.ttf";